import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.LossCode.Delete.IRequest;
type Response = Api.Core.LossCode.Delete.IResponse;
type Headers = Api.Core.LossCode.Delete.IHeaders;
const url = '/api/Claims/LossCode/:id';
export default async function lossCodeDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
